import React, { Component } from 'react'
import {
  Box,
  Button,
  Card,
  CardBody,
  CardHeader,
  Grid,
  Heading,
  Main,
  Paragraph,
  Text
} from 'grommet'
import axios from 'axios'
import { PageHeader } from './Common'
import { core } from '../api/retail'
import { FormClose, Play, PlayFill } from 'grommet-icons'
import PropTypes from 'prop-types'
import { AppContext } from '../libs/context'

const allowedFlows = [
  {
    id: 'triggerBulkScanToDonationFlow',
    heading: 'Bulk Scan to Donation',
    description: 'Simulates a retail database data flow from BulkScan to Donation table',
    path: '/flow'
  },
  {
    id: 'loadBulkScanToQa',
    heading: 'Load BulkScan To QA',
    description: 'Loads data From BulkScan to BulkScanQa table by calling event_qaload_bscan_to_qa',
    path: '/trigger/sproc'
  },
  {
    id: 'loadBulkScanQaToAdjScan',
    heading: 'Load BulkScanQA',
    description:
      'Loads data From BulkScanQa to AdjustedBulkScan table by calling event_load_bscanqa_to_adjbscan',
    path: '/trigger/sproc'
  },
  {
    id: 'migrateAdjScanToDonation',
    heading: 'Migrate AdjustedBulkScan to Donation',
    description:
      'Loads data From AdjustedBulkScan to Donation table by calling event_migrate_adjbscan_to_dn',
    path: '/trigger/sproc'
  },
  {
    id: 'preloadDonation',
    heading: 'Pre-load donation',
    description: 'Updates preload_dn table data event_preload_dn',
    path: '/trigger/sproc'
  }
]

const FlowCard = ({ heading, description, id, triggerFlowAction, path }) => (
  <Card flex={'grow'} elevation={'xlarge'} background={'white'}>
    <CardHeader
      pad={{ horizontal: 'medium', vertical: 'xsmall' }}
      border={{ side: 'bottom', color: 'light-3' }}
    >
      <Heading level={5} margin={'none'}>
        {heading}
      </Heading>
      <Button
        icon={<Play />}
        onClick={() => triggerFlowAction(`${path}/${id}`)}
        hoverIndicator
        color={'white'}
        plain={false}
      />
    </CardHeader>
    <CardBody
      fill
      flex={false}
      justify="start"
      align={'start'}
      pad={{ horizontal: 'large', vertical: 'small' }}
    >
      <Paragraph size={'medium'} color={'dark-6'}>
        {description}
      </Paragraph>
    </CardBody>
  </Card>
)

FlowCard.propTypes = {
  heading: PropTypes.string,
  description: PropTypes.string,
  id: PropTypes.string,
  path: PropTypes.string,
  triggerFlowAction: PropTypes.func
}
class Flows extends Component {
  state = { logs: [] }
  static contextType = AppContext
  componentDidMount() {
    // this.getLogs()
  }

  triggerFlow = (path) => {
    core
      .getFlow(path)
      .then()
      .catch((err) => this.context.actions.showResponseAsError(err))
  }
  render() {
    return (
      <Box fill>
        <PageHeader heading={'Flows'} />
        <Main pad="medium" flex="shrink" gap={'small'}>
          <Grid columns="medium" gap="medium">
            {allowedFlows.map((flowProps) => (
              <FlowCard key={flowProps.id} {...flowProps} triggerFlowAction={this.triggerFlow} />
            ))}
          </Grid>
        </Main>
      </Box>
    )
  }
}

export default Flows
